import FieldResponseModel from '../models/FieldResponseModel'
import GOFResponseModel from '../models/GOFResponseModel'
import {
   UnionFieldModelType,
   UnionFieldResponse,
   UnionFieldResponseModel
} from '../types/Field'

export const createFieldResponseModel = (
   fieldResponse: UnionFieldResponse,
   fieldModel: UnionFieldModelType,
   gofResponse?: GOFResponseModel
): UnionFieldResponseModel =>
   new FieldResponseModel<any, any, any>( //TODO: update the instance creation accordingly
      fieldResponse.fieldResponseId,
      fieldResponse.response,
      fieldModel,
      gofResponse
   )

export const updateFieldResponseModel = (
   fieldResponseModel: UnionFieldResponseModel,
   fieldResponse: UnionFieldResponse
) => {
   fieldResponseModel.setResponse(fieldResponse.response as any) //TODO: update the instance creation accordingly
}
